import { Box, Dialog } from '@mui/material'
import { addFyaAttachment } from 'api/services/automation/income-tax'
import FileDrop from 'components/FileDrop'
import LoadingButton from 'components/LoadingButton'
import { snack } from 'components/toast'
import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { GreyButton } from 'views/tasks/styles'

const UploadAttachmentModal = ({ open, setOpen, type, item }: any) => {
  const queryClient = useQueryClient();
  const [files, setFiles] = useState<File[]>([]);
  const params: any = useParams();

  const { mutate, isLoading } = useMutation(addFyaAttachment, {
    onSuccess: (res: any) => {
      snack.success("Attachment Added");
      setOpen(false);
      setFiles([]);
      queryClient.invalidateQueries("e-proceeding-notice");
      if (res?.data?.errors?.length) {
        for (let item of res?.data?.errors) {
          snack.error(item)
        }
        setFiles([]);
      }
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });
  const handleUpload = () => {

    if (!files || files.length === 0) {
      return snack.error("Please select file to upload.");
    }
    let formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
      formData.append("type", type);
      formData.append("responseId", item?.id)
    });
    let totalSize = 0;
    files.forEach(file => {
      totalSize += file.size;
    });
    if (!(totalSize < 209715200)) {
      return snack.error("Files size must be less than 200MB");
    }

    if (type === "Response") {
      mutate({
        autFyaNoticeId: params.itemId,
        data: formData,
      });

    } else if (type === "FyaNotice") {
      mutate({
        autFyaNoticeId: params.itemId,
        data: formData
      });
    }

  };

  return (
    <>
      <Dialog sx={{ m: 2 }} maxWidth="md" fullWidth open={open} onClose={() => setOpen(null)}>
        <FileDrop multiple sx={{ minHeight: 300 }} onChange={(files: File[]) => setFiles(files)} />
        <Box sx={{ mt: 2, display: "flex", gap: 2, justifyContent: "center", mb: 1 }}>
          <LoadingButton
            title="Upload Files"
            disabled={!files.length || isLoading}
            disableElevation
            color="secondary"
            loading={isLoading}
            onClick={handleUpload}
          />
          <GreyButton onClick={() => setOpen(false)}>Cancel</GreyButton>
        </Box>
      </Dialog>
    </>
  )
}

export default UploadAttachmentModal